import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SiNo } from "app/features/selectores/index";


type Entity = models.MatrizTarifaRangoEspecial;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un MatrizTarifaRangoEspecial
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        ImporteFlete: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un MatrizTarifaRangoEspecial
*/
export class MatrizTarifaRangoEspecialEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);
        const Number = getField(kea.Number);
        const Check = getField(kea.Checkbox);
        const Sucursal = getField(selectores.Sucursal);
        const Descripcion = getField(selectores.DescripcionPaquete);
        const Contenido = getField(selectores.ContenidoPaquete);
        const SiNo = getField(selectores.SiNo);
        const ZonaExtendida = getField(selectores.ZonaExtendida);


        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Editar rango especial"
            >
                <div className="alert alert-info">
                    <ul>
                        <li>
                            Este rango va a sustituir el flete del paquete siempre y cuando encaje con los filtros de distancia, peso, peso volumetro, etc...
                    </li>
                        <li>
                            Dejar el filtro vacío implica que ese filtro siempre va a aplicar, por ejemplo, si se dejan vacíos los filtros de rangos de peso y peso volumétrico este rango
                            afectará para cualquier peso.
                        </li>
                        <li>
                            El filtro de sucursales no es de dos vías, es decir, si se selecciona origen A y destino B, este no va a aplicar para origen B y destino A, en caso de que se quiera aplicar
                            un rango para dos direcciones se tienen que capturar dos rangos.
                        </li>
                        <li>
                            También se puede filtrar por tipo de servicio utilizando los checks <b>AplicaSobre</b> y <b>AplicaPaquete</b>, si estos dos estan deshabilitado el rango no aplicará
                            para ningún servicio
                        </li>
                    </ul>
                </div>


                {kea.autogrid(3, [
                    <Number field="ImporteFlete" label="Importe del flete" format="currency" />,
                    <Number field="PorcentajeValorFactura" label="Porcentaje del valor factura" format="percentage" />,
                ])}

                <kea.Panel iconClass={fa("filter")} title="Filtros" >
                    {kea.autogrid(3, [
                        <Number field="DistanciaMinima" label="Distancia mínima" />,
                        <Number field="DistanciaMaxima" label="Distancia máxima" />,

                        <Number field="PesoMinimo" label="Peso mínimo" />,
                        <Number field="PesoMaximo" label="Peso máximo" />,

                        <Number field="PesoVolumetricoMinimo" label="Peso vol. mínimo" />,
                        <Number field="PesoVolumetricoMaximo" label="Peso vol. máximo" />,

                        <Check field="AplicaPaquete" label="Aplica para paquete" />,
                        <Check field="AplicaSobre" label="Aplica para sobre" />,

                        <Sucursal field="IdSucursalOrigen" label="Sucursal origen" />,
                        <Sucursal field="IdSucursalDestino" label="Sucursal destino" />,

                        <Descripcion field="IdDescripcionPaquete" label="Descripción paquete" />,
                        <Contenido field="IdContenidoPaquete" label="Contenido paquete" />,

                        <Number field="VolumenMinimo" label="Volumen mínimo" />,
                        <Number field="VolumenMaximo" label="Volumen máximo" />,

                        <Number field="MedidaLargoMinimo" label="Medida largo mínimo" />,
                        <Number field="MedidaLargoMaximo" label="Medida largo máximo" />,

                        <Number field="MedidaAltoMinimo" label="Medida alto mínimo" />,
                        <Number field="MedidaAltoMaximo" label="Medida alto máximo" />,

                        <Number field="MedidaAnchoMinimo" label="Medida ancho mínimo" />,
                        <Number field="MedidaAnchoMaximo" label="Medida ancho máximo" />,

                        <Number field="ValorFacturaMinimo" label="Valor factura mínimo" />,
                        <Number field="ValorFacturaMaximo" label="Valor factura máximo" />,

                        <SiNo field="SucursalOrigenIgualDestino" label="Sucursal origen igual a destino" />,

                        <SiNo field="EsZonaExtendida" label="Tarifa especial aplica a zona extendida" />,
                        <ZonaExtendida field="IdZonaExtendida" label="Zona extendida" />
                    ])}
                </kea.Panel>
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/rangosespeciales/edit.tsx